import styled from "styled-components";
import { TextWidget } from "../../../components/widget/text-widget";


export const StyledTextWidget = styled(TextWidget)`
  // min-width: 100%;
`;
